const INLINE_PARAMS_MAX_LENGTH = 48
const MULTILINE_PARAMS_MIN_COUNT = 4
const INDENT = '  '

export function formatCodeSnippetParams(parameterNames: string[]): string {
  const inlineParams = parameterNames.join(', ')

  if (!inlineParams) {
    return ''
  }

  if (parameterNames.length < MULTILINE_PARAMS_MIN_COUNT && inlineParams.length <= INLINE_PARAMS_MAX_LENGTH) {
    return inlineParams
  }

  return `\n${INDENT}${parameterNames.join(`,\n${INDENT}`)}\n`
}
